import { render, staticRenderFns } from "./_text.input.vue?vue&type=template&id=0f9cec96&"
import script from "./_text.input.vue?vue&type=script&lang=ts&"
export * from "./_text.input.vue?vue&type=script&lang=ts&"
import style0 from "./_text.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports